import loadable from '@loadable/component';

const TagPage = loadable(() => import('./TagPage'));

export { TagPage };
